import { ProductionComponentInstanceStatus } from '@paragon/contract-library';

/**
 * All of the statuses, in their order of progression
 */
export const defaultStatusList: readonly ProductionComponentInstanceStatus[] = [
  'Unscheduled',
  'Scheduled',
  'StartedAssembly',
  'FinishedAssembly',
  'StoredOnYard',
  'Shipped',
  'Delivered',
];
